function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: "32.9351247%",
  cy: "22.4100935%",
  fx: "32.9351247%",
  fy: "22.4100935%",
  r: "0.139277253%",
  gradientTransform: "translate(0.329351,0.224101),scale(0.972727,1.000000),translate(-0.329351,-0.224101)",
  id: "radialGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4B2B36",
  stopOpacity: 0.98,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#250012",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "indesign",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  fill: "url(#radialGradient-1)",
  points: "1.47519825 1.5195678 33.9300357 1.5195678 33.9300357 33.0892744 1.47519825 33.0892744"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.47519825,1.5195678 L33.9300357,1.5195678 L33.9300357,33.0892744 L1.47519825,33.0892744 L1.47519825,1.5195678 Z M0,34.5645321 L35.405234,34.5645321 L35.405234,0.044369548 L0,0.044369548 L0,34.5645321 Z M22.3938343,14.3834655 C22.1725218,14.2802141 21.8774584,14.2359635 21.5233941,14.2359635 C19.6203806,14.2359635 18.2926844,15.696471 18.2926844,18.1305512 C18.2926844,20.9039453 19.649881,22.0250793 21.3464512,22.0250793 C21.7152062,22.0250793 22.0987708,21.9808287 22.3938343,21.8480769 L22.3938343,14.3834655 Z M21.6118953,11.9788858 C21.9217089,11.9788858 22.0987708,11.9788858 22.3937748,12.0083862 L22.3937748,8.08429818 C22.3937748,7.98104679 22.4675258,7.93679622 22.5412173,7.93679622 L24.9311062,7.93679622 C25.0491079,7.93679622 25.0786083,7.98104679 25.0786083,8.05479778 L25.0786083,21.8481364 C25.0786083,22.2611419 25.0786083,22.7775178 25.1523593,23.3380848 C25.1523593,23.4413362 25.1228589,23.4560864 25.0196075,23.5151467 C23.750912,24.1199643 22.408525,24.3855273 21.1545797,24.3855273 C17.8943696,24.3855273 15.5634814,22.3645123 15.5634814,18.2486122 C15.5487907,14.7227795 17.8796193,11.9788858 21.6118953,11.9788858 Z M12.9524583,23.9724623 C12.9524583,24.1199048 12.9229579,24.1642149 12.7606463,24.1642149 L10.4888184,24.1642149 C10.3413164,24.1642149 10.2970063,24.0904639 10.2970063,23.9724623 L10.2970063,8.12854876 C10.2970063,7.98104679 10.3707573,7.93673675 10.4888184,7.93673675 L12.7753965,7.93673675 C12.8933981,7.93673675 12.9524583,7.98098732 12.9524583,8.11379859 L12.9524583,23.9724623 Z",
  id: "Shape",
  fill: "#FF408C"
})));

var SvgIndesign = function SvgIndesign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "35px",
    viewBox: "0 0 36 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indesign.b987667f.svg";
export { ForwardRef as ReactComponent };